<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";

export default {
  mixins: [ContextMenuMixin],
  computed: {
    menu() {
      let menu = [
        {
          label: "View Details",
          action: () => {
            this.goToRoute("training.users.show", { user: this.item.id });
          },
        },
        {
          label: "View Hours",
          action: () => {
            this.showHoursModal();
          },
        },
        {
          label: "View Training",
          action: () => {
            this.goToRoute("admin.users.history.index", {
              user: this.item.id,
              type: "online",
            });
          },
        },
      ];

      if (this.item.can_portray && this.$root.isAdmin) {
        menu.push({
          label: "Portray User",
          action: () => {
            window.location = `/?portray=${this.item.id}`;
          },
        });
      }

      if (this.$root.isAdmin) {
        menu.push({
          label: "Edit User",
          action: () => {
            this.goToRoute("admin.users.edit", { user: this.item.id });
          }
        });
      }

      return menu;
    },
  },
  methods: {
    showHoursModal() {
      this.$modal("HoursModal", { user: this.item })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>